import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Contacts } from "./types";

import { Data } from "@/shared/types.ts";
import api from "@/shared/api";

const CONTACTS_KEY = "contacts";

export function useContacts() {
  return useQuery<Data<Contacts>>({
    queryKey: [CONTACTS_KEY],
    queryFn: (ctx) =>
      api
        .get<Data<Contacts>>("/api/v1/admin/contacts", { signal: ctx.signal })
        .json(),
  });
}

export function useUpdateContacts() {
  const queryClient = useQueryClient();

  return useMutation<Data<Contacts>, Error, Contacts>({
    mutationFn: (contacts) =>
      api.put("/api/v1/admin/contacts", { json: contacts }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CONTACTS_KEY] });
    },
  });
}
